var $ = require('jquery'),
	$w = $(window);

var gc = module.exports = {
	scrollable: false,
	scrollDirection: {},
	draw: function( frequency, stop ){
		
		$w.trigger('gc:draw');
		
		if( frequency ){
			
			var interval = setInterval(function(){
				$w.trigger('gc:draw');
			}, frequency);
			
			setTimeout(function(){
				clearInterval(interval);
			}, stop || 1000);
		}
	},
	on: $w.on.bind($w),
	trigger: $w.trigger.bind($w)
};

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
gc.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

// whether scroll listeners are worth it
$w.on('resize', function(){ 
	gc.scrollable = ($('body').height() - $w.height() > 50);
});

var lastScrollTop = 0;

$w.on('scroll', function(){ 
	if(gc.scrollable){
		var st = $w.scrollTop();
		gc.scrollDirection.up = st < lastScrollTop;
		gc.scrollDirection.down = !gc.scrollDirection.up;
		lastScrollTop = st;
		$w.trigger('gc:scrolling', [st]);
	}
});

$w.on('gc.scrolling', function(e, scrollTop){
    $b[ scrollTop > (windowHeight/3) ? 'addClass' : 'removeClass' ]('past-halfway');
})

$w.on('scroll', gc.debounce(function(){
	$w.trigger('gc:scrolled', [$w.scrollTop()]);
}, 100));

// call layout value resetters after resize
$w.on('resize', gc.debounce(function(){
	$w.trigger('gc:scrolled', [$w.scrollTop()]);
	$w.trigger('gc:resized');
}, 250));

$w.on('gc:scrolled', function(){
	$w.trigger('gc:draw');
});

$w.on('gc:resized', function(){
	$w.trigger('gc:draw');
});

gc.where = function(selector, callback){
	$(document).ready(function(){
		$(selector).each(function( index ){
			callback.bind(this)($(this), index);
		});
	});
};

gc.when = function(selector, callback){	
	
	gc.where(selector, callback);
	
	$w.on('gc:dom', function(e, $container){
		$(selector, $container).each(function( index ){
			callback.bind(this)($(this), index);
		});
	});
};

$(document).ready(function(){
	$w.trigger('gc:draw');
});

/* IE10 dropped conditional comments. This is not good, cos IE10 is still broken */

if((window.navigator.userAgent.indexOf("MSIE ") > -1) || (window.navigator.appVersion.indexOf('Trident/') > 0))
	$('html').addClass('ie');


//////////////////
// WEBPACK FOOTER
// ./themes/gc/js/gc.js
// module id = 2
// module chunks = 0